export default __webpack_public_path__ + "img/PIC_HE_Resilience_fw_de_de_92812.jpg";